import {
  GoogleAuthProvider,
  inMemoryPersistence,
  setPersistence,
  signInWithPopup,
  signOut
} from "firebase/auth";
import { getCsrfToken } from "./api";
import { getFirebaseAuth, getPortalAppCheckToken } from "./firebaseClient";
import { IS_MOCK } from "./runtime";
import { exchangePortalSession } from "./sessionBootstrap";

export async function startGoogleSession(): Promise<void> {
  if (IS_MOCK) return;
  const auth = getFirebaseAuth();
  await setPersistence(auth, inMemoryPersistence);
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const result = await signInWithPopup(auth, provider);
  // Reuse the valid token created at app startup. Forcing a second reCAPTCHA
  // assessment immediately after the Google popup can trigger provider
  // throttling without adding meaningful protection.
  const appCheckToken = await getPortalAppCheckToken();

  const invitationId = new URLSearchParams(window.location.search).get("invite") ?? undefined;
  await exchangePortalSession(() => result.user.getIdToken(true), appCheckToken, invitationId);
}

export async function endSession(): Promise<void> {
  if (IS_MOCK) return;
  const csrfToken = await getCsrfToken();
  const appCheckToken = await getPortalAppCheckToken();
  await fetch("/api/session/logout", {
    method: "POST",
    credentials: "include",
    headers: {
      "X-CSRF-Token": csrfToken,
      ...(appCheckToken ? { "X-Firebase-AppCheck": appCheckToken } : {})
    }
  });
  await signOut(getFirebaseAuth());
}
